(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sections = document.querySelectorAll('[data-product-recommendations-section][data-recommendations-loaded="false"]');
    if (!sections.length) return;

    sections.forEach(async (sectionEl) => {
      const url = sectionEl.getAttribute('data-recommendations-url');
      const sectionId = sectionEl.getAttribute('data-product-recommendations-section-id');
      if (!url || !sectionId) return;

      try {
        const response = await fetch(url);
        if (!response.ok) throw new Error(`HTTP ${response.status}`);

        const html = await response.text();
        const parsedHtml = document.createElement('div');
        parsedHtml.innerHTML = html;

        const nextSection = parsedHtml.querySelector(
          `[data-product-recommendations-section][data-product-recommendations-section-id="${sectionId}"]`
        );

        if (nextSection) {
          sectionEl.replaceWith(nextSection);
        } else {
          sectionEl.remove();
        }
      } catch (error) {
        console.error('Failed to load product recommendations section', error);
        sectionEl.remove();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
